import { actionBound, computed, observable, observableStruct } from "mobx";

import type { QmsConfig, User } from "../interfaces";

const readShowInfo = (): boolean | undefined => {
  const raw = localStorage.getItem("showInfo");
  if (!raw) return undefined;

  try {
    const parsed = JSON.parse(raw) as { showInfo?: boolean };
    return typeof parsed.showInfo === "boolean" ? parsed.showInfo : undefined;
  } catch {
    return undefined;
  }
};

class AppStore {
  @observableStruct accessor config: QmsConfig = {
    language: "en",
  };

  @observable accessor infoDisplayed = true;

  constructor() {
    const beenHere = localStorage.getItem("beenHere") === "1";
    const storedShowInfo = readShowInfo();

    if (storedShowInfo !== undefined) {
      this.infoDisplayed = storedShowInfo;
    } else {
      this.infoDisplayed = !beenHere;
    }
  }

  @computed
  get user(): User | undefined {
    return this.config.user;
  }

  @computed
  get loggedIn() {
    return this.user?.username;
  }

  @actionBound
  async logIn() {
    if (process.env.NODE_ENV === "production") {
      const wasHere = localStorage.getItem("beenHere") === "1";
      localStorage.setItem("beenHere", "1");

      if (!wasHere && localStorage.getItem("showInfo") === null) {
        localStorage.setItem("showInfo", JSON.stringify({ showInfo: false }));
        this.infoDisplayed = false;
      }
    }
  }

  @actionBound
  setInfoDisplayed(val: boolean) {
    this.infoDisplayed = val;
    localStorage.setItem("showInfo", JSON.stringify({ showInfo: val }));
  }

  @actionBound
  toggleInfoDisplayed() {
    this.setInfoDisplayed(!this.infoDisplayed);
  }

  @actionBound
  logOut() {
    localStorage.removeItem("authToken");
  }

  @actionBound
  setConfig(config: QmsConfig) {
    this.config = config;
  }
}

const appStore = new AppStore();

export { appStore };
